import { HardwareCategory, Product } from '@shared/models/product.model';
import { Equipment } from '@sales/models/order-capture.model';
import { PaymentType } from '../enums/payment-type';
import { AccessoryItem, SubscriptionForHardwareOffering } from '@app/sales/models/accessory.model';
import { EquipmentPaymentType } from '@app/sales/enums/equipment-payment-type';

export class HardwareProduct extends Product {
  subscriptionId?: string;
  equipment: Equipment;
  paymentType: PaymentType | EquipmentPaymentType;
  hardwareCategory: HardwareCategory;
  voiceProductId: string;
  selectedSubscription?: SubscriptionForHardwareOffering;
  subscriptionIdToUpgrade?: string;
  accessoryVariant?: AccessoryItem;
  subscriptionOfferingId?: string;

  constructor() {
    super();
    this.paymentType = PaymentType.Upfront;
  }
}

export class HardwareProductTestBuilder {
  private _hardwareProduct: HardwareProduct = new HardwareProduct();

  public Default() {
    this._hardwareProduct.id = '1';
    this._hardwareProduct.equipment = new Equipment();
    return this;
  }

  public Build() {
    return this._hardwareProduct;
  }
}
